import {EventType, PublicClientApplication, SilentRequest} from "@azure/msal-browser";
import {EventPayload} from "@azure/msal-browser/dist/event/EventMessage";

export const msalInstance = new PublicClientApplication({
  auth: {
    clientId: import.meta.env.VITE_AZURE_B2C_APP_ID,
    authority: import.meta.env.VITE_AZURE_B2C_AUTHORITY,
    knownAuthorities: [import.meta.env.VITE_AZURE_B2C_KNOWN_AUTHORITY],
    redirectUri: import.meta.env.VITE_AZURE_B2C_REDIRECT_URI,
  },
});

if (!msalInstance.getActiveAccount() && msalInstance.getAllAccounts().length > 0) {
  msalInstance.setActiveAccount(msalInstance.getAllAccounts()[0]);
}

export const hasAccount = (payload: EventPayload): payload is SilentRequest =>
  !!payload && Object.keys(payload).includes("account");

msalInstance.addEventCallback((event) => {
  if ((event.eventType === EventType.LOGIN_SUCCESS ||
      event.eventType === EventType.ACQUIRE_TOKEN_SUCCESS ||
      event.eventType === EventType.SSO_SILENT_SUCCESS) &&
      hasAccount(event.payload) && event.payload.account) {
    msalInstance.setActiveAccount(event.payload.account);
  }
});
